export const setDestinationStoreLocations = {
  SET_DESTINATION_STORE_LOCATIONS(state, payload) {
    state.destinationStoreLocations = payload;
  }
};
